module.exports = __webpack_public_path__ + "img/img-web-subsidio-union.496995a2.png";